import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

let registered = false;

// The whole enterprise bundle, not per-feature modules: `filter: true` in the
// shared defaultColDef resolves to the set filter only when SetFilterModule is
// registered, and the grids rely on that resolution everywhere.
export function bootstrapAgGrid() {
  if (registered) return;
  registered = true;
  ModuleRegistry.registerModules([AllEnterpriseModule]);
}
